import { Layout } from "antd";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

const { Header, Sider, Content } = Layout;

const MainLayout = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        width={240}
        breakpoint="lg"
        collapsedWidth="0"
        style={{
          backgroundColor: "#001529", // match AntD dark theme
        }}
      >
        <Sidebar />
      </Sider>

      {/* Main Content Area */}
      <Layout>
        {/* Top Navbar */}
        <Header
          style={{
            background: "transparent",
            backgroundColor: "#001529",
            padding: 0,
          }}
        >
          <Navbar />
        </Header>
        {/* Page Content */}
        <Content className="p-2 mt-3">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
